export function setMenu(data) {
  return {
    type: 'SET_MENU',
    data
  };
}